// Tadam Academy — Zimbabwean Education System Constants
// Central source of truth for grades, divisions, and currency

export const CURRENCY = '$';
export const CURRENCY_LABEL = 'USD';

export const DIVISIONS = [
  {
    name: 'Pre-School (ECD)',
    shortName: 'ECD',
    ages: 'Ages 3-5',
    grades: ['ECD A', 'ECD B'],
  },
  {
    name: 'Primary School',
    shortName: 'Primary',
    ages: 'Ages 6-12',
    grades: ['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7'],
  },
  {
    name: 'High School',
    shortName: 'High School',
    ages: 'Ages 13-19',
    grades: ['Form 1', 'Form 2', 'Form 3', 'Form 4 (O-Level)', 'Form 5 (A-Level)'],
  },
];

export const ALL_GRADES = DIVISIONS.flatMap(d => d.grades);

export const DIVISION_OPTIONS = DIVISIONS.map(d => ({ value: d.shortName, label: d.name }));

export const formatCurrency = (amount) => {
  if (amount == null || isNaN(amount)) return `${CURRENCY}0.00`;
  return `${CURRENCY}${Number(amount).toFixed(2)}`;
};
